import BsUtil from './../BsUtil'
import BsGetCid from './../BsGetCid'
import Env from "./../BsGetEnv"
function net(ua){
  try{
    if (navigator.connection) {
      return navigator.connection.effectiveType
    } else {
        var n = ['wifi', '4g', '3g', '2g']
        for (var i = 0; i < n.length; i++){
          if (ua.indexOf(n[i]) > -1) return n[i]
        }
        return 'other'
    }
  } catch(error){
    console.log(error)
  }
}
const toGetParams = (function getParams() {
  return new Promise((resolve)=>{
    try {
      if(Env.inApplication && BsUtil.compareVersion(Env.curAppVersion, '9.65.0') >= 0 &&  window.DIDASDK){
        window.DIDASDK.invoke('getTracker',{},res => {
          if (res) {
            const obj = JSON.parse(res) || {}
            // console.log('getTracker================>', res, 'obj===========>', obj)
            resolve({
              session_id: obj?.sid || '',
              from_page_name: obj?.fn || '',
              from_page_action_id: obj?.pid || ''
            });
          } else {
              resolve({});
          }
        })
      } else {
        resolve({});
      }
    } catch (error) {
        resolve({});
    }
  })
})()
function createXMLHttp() {
  try {
    if(window.XMLHttpRequest){
      return new XMLHttpRequest()
    }else{
      var arr = ["MSXML2.XMLHttp.6.0", "MSXML2.XMLHttp.5.0", "MSXML2.XMLHttp.4.0", "MSXML2.XMLHttp.3.0", "MSXML2.XMLHttp", "Microsoft.XMLHttp"];
      for (var i = 0; i < arr.length; i++) {
        try {
          return new ActiveXObject(arr[i]);
        } catch (error) {
          console.log(error)
        }
      }
    }
  } catch (error) {
    console.log(error)
  }
  
}
function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
export default class stat {
  constructor(config){
    this.type = config.type || 'H5',
    this.name = config.name
    this.cid = config.cid
    this._ua = navigator.userAgent.toLocaleLowerCase()
    this.pageActionID = config.name + "_" + (new Date()).valueOf(),
    this.savePathname = window.location.pathname
    this.seq = 0
    this.saveParams = {}
    // this.send()
  }
  async send(code, data, callback){
    this.saveParams = await toGetParams
    data = data || {};
    try {
      var params = {}
      for (var i in data) {
        if( i == "app_name" || i == "app_user_cid" || i == "user_cid" || i == "currentEnv") continue
        params[i] = data[i]
      }
      let CID = data.cid || data.user_cid || data.app_user_cid || this.cid || (await BsGetCid()).cid
      const trakData = [{
        "c_info":{
          "channelId": BsUtil.queryString('channelId'),
          "channelSceneId": BsUtil.queryString('channelSceneId'),
          "domain": location.hostname || location.host,
          ...params,
        },
        "event_time": (new Date()).valueOf(),
        "pageActionID": this.pageActionID,
        "seq": this.seq,
        "session_id": this.saveParams.session_id || '',
        "from_page_name": this.saveParams.from_page_name || '',
        "from_page_action_id": this.saveParams.from_page_action_id || '',
        "currentEnv": data.currentEnv,
        "stat_type":"view",
        "content": data.content || data.innerText || data.name || this.name,
        "actions": code,
        "ua": navigator.userAgent,
        "net": net(this._ua),
        "pageUrl": location.href,
        "title": encodeURIComponent(document.title) || '',
        "referrer": document.referrer || '',
        "app_type": this.type,
        "app_user_cid": CID || -1,
        "app_name": data.app_name || this.name
      }]
      // console.log('trakData[0=================]', trakData[0])
      let url = 'https://pluto.didapinche.com/web/tracking'
      if(fetch && location.href.indexOf('console') === -1 && (document.referrer || '').indexOf('console') === -1){
        fetch(url, {
          method: 'post',
          body: JSON.stringify(trakData),
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
          },
          keepalive: true
        })
        .then(response => response.json())
        .then(data => callback && callback(data))
        .catch(data => callback && callback(data));
      } else {
        var xhr = createXMLHttp();
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send(JSON.stringify(trakData));
        if (callback) {
            xhr.onreadystatechange = function() {
                if (xhr && xhr.readyState == 4) {
                    var status = xhr.status;
                    if (status >= 200 && status < 300) {
                        var response = xhr.response && JSON.parse(xhr.response) || {};
                        callback(response)
                    } else {
                        callback(500, [])
                    }
                }
            }
        }
      }
    if(this.savePathname === window.location.pathname) {
      this.seq+=1
    } else {
      this.pageActionID = this.name + "_" + (new Date()).valueOf()
      this.seq=0
      this.savePathname = window.location.pathname
    }
    } catch (error) {
      console.log(error)
      callback && callback()
    }
  }
}